// SPDX-License-Identifier: AGPL-3.0-or-later

import yapnetIcon from '@app/media/images/yapnet-icon.png';
import yapnetLogo from '@app/media/images/yapnet-logo.png';

/**
 * Single place to change the instance's product identity.
 * Change BRAND_NAME (and the image files/imports below) to rebrand everything.
 */
export const BRAND_NAME = 'YapNet';

/** Full logo (icon + wordmark) used on the sign-in page, sidebar home, splash, etc. */
export const BRAND_LOGO = yapnetLogo;

/** Square icon (face mark) used for the sidebar home button, favicons, and small glyphs. */
export const BRAND_ICON = yapnetIcon;
